import { connect } from "react-redux";

import Button from "@components/Button";
import { addModal } from "@store/app/actions";
import { PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID } from "@components/Lockers/_lib/constants";

const UserWithoutLocker = ({ addModal }) => {
  const handleAddLockerModal = (event) => {
    event.preventDefault();
    addModal(PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID);
  };

  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]">
      <div className="text-[14px] font-medium mb-[10px] lg:mb-0">
        <div>Punct de ridicare</div>
        <span className="text-[#808080] text-[12px] leading-[14px]">
          Selecteaza un punct favorit
        </span>
      </div>

      <Button
        title="Selecteaza"
        size="small"
        variant="third"
        isOrderAgain
        onClick={handleAddLockerModal}
      />
    </div>
  );
};

export default connect(null, { addModal })(UserWithoutLocker);
